module.exports = __webpack_public_path__ + "images/signup-panda-2x.png";


//////////////////
// WEBPACK FOOTER
// ./images/signup-panda-2x.png
// module id = 1130
// module chunks = 1